import React from "react";
import Image from "next/image";
import type { BlockProps } from "./blocks/registry";
import { Heading } from "../design-system/atoms/Heading";
import { Paragraph } from "../design-system/atoms/Paragraph";
import Link from "next/link";
import { resolveLegacyLink } from "../utils/linkUtils";

export default function Service({ data }: BlockProps<any>) {
  if (!data) return null;

  const mappedServices =
    data.service?.map((s: any) => ({
      id: s.id,
      title: s.titre,
      descr: s.descr,
      iconSrc: s.icon?.url,
      cta: s.cta.link,
      iconHoverSrc: s.iconHover?.url,
    })) ?? [];

  const imageSrc = data.image?.url;

  return (
    <section
      className="lms-container py-12"
      key={data.documentId}
    >

      <div className="text-center mb-8">
        <Heading as="h2" className="text-4xl md:text-5xl font-bold text-text">
          {data.titre.split(" ").slice(0, -1).join(" ")}{" "}
          <span className="text-secondary">
            {data.titre.split(" ").slice(-1)}
          </span>
        </Heading>
        {data.descr && <Paragraph>{data.descr}</Paragraph>}
      </div>

      <div className="flex flex-col lg:flex-row items-center justify-center gap-0 ">
        <div className="relative">
          <div className="relative w-full h-full rounded-3xl overflow-hidden z-10">
            <Image src={imageSrc} alt={data.titre} width={640} height={731} />
          </div>
        </div>

        {/* Liste de services */}
        <div className="w-full lg:w-1/2 bg-secondaryGreen rounded-3xl p-10">
          <div className="space-y-6">
            {mappedServices.map((s, i) => (
              <div
                key={s.id ?? i}
                className="flex  items-center flex-col xl:flex-row gap-4 hover:bg-white p-4 rounded-2xl border-none shadow-sm hover:shadow-md hover:v-primaryGreen transition-all duration-300"
              >
                <img
                  src={s.iconSrc}
                  alt={s.title}
                  className="w-20 h-20 object-contain"
                />
                <div>
                  <Link href={resolveLegacyLink(s.cta)}>
                    <h3 className="text-secondary font-semibold text-lg mb-1 text-center xl:text-start">
                      {s.title}
                    </h3>
                  </Link>

                  <p className="text-gray-700 text-sm font-medium leading-relaxed text-center xl:text-start">
                    {s.descr}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

    </section>
  );
}
